<template>
    <div class="salepage-item">
        <salepage-body-sidebar-component
            :salePage="salePage"
            :menus="menus"
            :pre_selected_menu="selectedMenu"
            :queue="queue"
            @changeSelectedMenu="changeSelectedMenu"
            @openCartModal="openCartModal"
        >
        </salepage-body-sidebar-component>
        <div class="salepage-product__flash-sale" v-if="checkFlashSale()">
            <div class="salepage-product__flash-sale--title">
                <h4>FLASH SALE</h4>
            </div>
            <div class="salepage-product__flash-sale--hr"></div>
            <coundivown-time
                :date="salePage.date_to"
                title="FLASH SALE"
            ></coundivown-time>
        </div>

        <div
            id="salepage-product"
            class="salepage-product tw-mt-5"
            v-if="salePageProduct.length > 0"
        >
            <h2 
                class="tw-text-center tw-font-semibold tw-text-4xl tw-mb-10"
                v-bind:class="{'text-white': isbgDark}"
            >
                สินค้าของเรา
            </h2>

            <div v-if="salePage.menu_style == 'classic'">
                <salepage-body-classic-product-component
                    :salePageProduct="salePageProduct"
                    :salePage="salePage"
                    :currency="currency"
                    :queue="queue"
                    :isbgDark="isbgDark"
                    @addToCart="addToCart"
                ></salepage-body-classic-product-component>
            </div>
            <div v-else-if="salePage.menu_style == 'modern'">
                <salepage-body-modern-product-component
                    :salePageProduct="salePageProduct"
                    :salePage="salePage"
                    :currency="currency"
                    :queue="queue"
                    :isbgDark="isbgDark"
                    @addToCart="addToCart"
                ></salepage-body-modern-product-component>
            </div>
            <div v-else>
                <salepage-body-grid-product-component
                    :salePageProduct="salePageProduct"
                    :salePage="salePage"
                    :currency="currency"
                    :queue="queue"
                    :isbgDark="isbgDark"
                    @addToCart="addToCart"
                ></salepage-body-grid-product-component>
            </div>
            <div></div>
            <!-- <div
                class="tw-flex tw-justify-center tw-stretch tw-w-full tw-sticky tw-bottom-2 tw-mt-4 tw-z-50"
                @click="cartModalOpen = true"
                v-if="queue.length > 0"
            >
                <button
                    type="button"
                    class="tw-flex tw-justify-between tw-w-full tw-p-2 tw-rounded tw-text-md"
                    :style="`background-color:${salePage.button_color}; color: ${salePage.button_text};`"
                >
                    <div>
                        <div class="tw-flex tw-justify-start">
                            <small>{{ queue.length }} รายการ</small>
                        </div>
                        <div>
                            {{ currency ? currency.symbol : '' }}
                            {{
                                Number(totalPrice).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }}
                        </div>
                    </div>
                    <div class="tw-text-xl tw-self-center">
                        <i class="fa fa-shopping-cart"></i> ดูตะกร้า
                    </div>
                </button>
            </div> -->
            <!-- ตะกร้าสินค้า -->
            <salepage-body-cart-component
                :salePage="salePage"
                :isOpen="cartModalOpen"
                title="ตะกร้าสินค้า"
                @closeModal="cartModalOpen = false"
            >
                <template v-slot:item-table>
                    <div v-if="queue.length > 0" class="">
                        <div
                            v-for="(item, index) in queue"
                            :key="index"
                            class="row tw-p-2 tw-my-2 tw-flex tw-justify-between tw-w-full"
                            :class="
                                index + 1 == queue.length
                                    ? ''
                                    : 'border-section-bottom'
                            "
                        >
                            <div class="tw-flex tw-w-3/5">
                                <div
                                    class="tw-flex tw-justify-center tw-mr-2 tw-w-4/5"
                                >
                                    <div class="form-group row">
                                        <div
                                            class="pr-0 image-container tw-rounded-lg"
                                        >
                                            <img
                                                :src="
                                                    `${item.product_data.image_url}`
                                                "
                                                class="tw-rounded-lg tw-w-full"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tw-mr-2 tw-px-2 tw-break-all tw-w-3/5"
                                >
                                    <div
                                        class="cart-product__name tw-text-sm tw-break-all tw-w-full"
                                    >
                                        {{ item.product_data.name }}
                                    </div>
                                    <div
                                        class="quantity-selector tw-text-sm tw-mr-3 tw-mt-2 tw-py-1 tw-w-4/6 tw-items-center tw-rounded-full tw-flex tw-justify-around tw-text-bold"
                                        :style="styleObject"
                                    >
                                        <div
                                            class="pl-2 tw-cursor-pointer"
                                            :disabled="item.quantity <= 1"
                                            @click="
                                                item.quantity > 1
                                                    ? (item.quantity =
                                                          item.quantity - 1)
                                                    : '',
                                                    updateQueueQuantity()
                                            "
                                        >
                                            <i class="fa fa-minus"></i>
                                        </div>
                                        <div
                                            class="tw-text-center tw-px-2"
                                            style="width: 50px; border-left: 1px solid #dedede; border-right: 1px solid #dedede"
                                        >
                                            <input
                                                min="1"
                                                :max="
                                                    item.product_data
                                                        .stock_balance
                                                "
                                                type="number"
                                                v-model="item.quantity"
                                                @change="
                                                    checkStock(index),
                                                        updateQueueQuantity()
                                                "
                                            />
                                        </div>
                                        <div
                                            class="pr-2 tw-cursor-pointer"
                                            :disabled="
                                                item.quantity ==
                                                    item.product_data
                                                        .stock_balance
                                            "
                                            @click="
                                                item.quantity <
                                                item.product_data.stock_balance
                                                    ? (item.quantity =
                                                          item.quantity + 1)
                                                    : '',
                                                    updateQueueQuantity()
                                            "
                                        >
                                            <i class="fa fa-plus"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tw-flex tw-pr-2">
                                <div class="">
                                    <p class="tw-font-semibold tw-text-right">
                                        {{ currency ? currency.symbol : "" }}
                                        {{
                                            Number(
                                                item.product_data.price *
                                                    item.quantity
                                            ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2
                                            })
                                        }}
                                    </p>
                                </div>
                                <div>
                                    <a
                                        class="tw-px-2 tw-cursor-pointer tw-ml-2 tw-text-right"
                                        @click="removeProduct(item.product_id)"
                                    >
                                        <i class="fa fa-trash tw-text-red-500 hover:tw-text-red-700"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="tw-flex tw-justify-center tw-mt-2 tw-text-gray-400"
                    >
                        <h3>ไม่มีสินค้า</h3>
                    </div>
                </template>
                <template v-slot:total-price v-if="queue.length > 0">
                    <div
                        class="tw-flex tw-py-6 tw-justify-around tw-font-semibold tw-text-2xl border-section"
                    >
                        <div>
                            ราคารวม
                        </div>
                        <div>
                            {{ currency ? currency.symbol : "" }}
                            {{
                                Number(totalPrice).toLocaleString(undefined, {
                                    minimumFractionDigits: 2
                                })
                            }}
                        </div>
                    </div>
                </template>
                <template v-slot:footer v-if="queue.length > 0">
                    <div
                        v-if="salePage.type == 'sale' && queue.length > 0"
                        class="tw-w-full tw-flex tw-justify-center"
                    >
                        <button
                            type="button"
                            class="btn tw-mx-3 tw-rounded-full tw-w-full tw-text-xs"
                            :style="
                                `background-color:${salePage.button_color}; color: ${salePage.button_text};`
                            "
                            @click="orderPurchase"
                        >
                            <div class="tw-text-md tw-flex tw-justify-center">
                                <div>
                                    <i class="fa fa-shopping-bag mr-3"></i
                                    >สั่งซื้อสินค้า 
                                </div>
                            </div>
                        </button>
                    </div>
                </template>
            </salepage-body-cart-component>
        </div>

        <div v-if="salePage.type == 'form' && formSalePageData">
            <form-component
                :title="formSalePageData.title"
                :description="formSalePageData.description"
                :formBodies="formSalePageData.bodies"
                :shop="shop"
                :salepage_id="salepage_id"
                :base_url="api_url"
            />
        </div>
        <div class="salepage-product__cart"></div>
    </div>
</template>
<style lang="scss" scoped>
input {
    border: 0;
    outline: 0;
    text-align: center;
}

input:focus {
    outline: none !important;
}

.salepage-product__detail--close-button {
    border: 1px solid var(--button-color);
}

.salepage-product__detail--close-button:hover {
    background-color: var(--button-color);
    color: var(--button-text);
}

.quantity-selector {
    border: 1px solid var(--button-color);
}

.border-section-bottom {
    border-bottom: 2px solid #dedede;
}

.border-section {
    border-top: 2px solid #dedede;
    border-bottom: 2px solid #dedede;
}

.image-product-cart {
    width: 50%;
}

.table tbody tr div {
    white-space: normal;
}

.table tbody th div {
    vertical-align: top;
}

.image-container {
    width: 60px;
    aspect-ratio: 1 / 1;
}

.image-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

@media (min-width: 0px) and (max-width: 768px) {
    .cart-product__name {
        max-width: 120px;
    }

    .quantity-selector {
        width: 110px;
    }
}

@media screen and (min-width: 769px) {
    .cart-product__name {
        max-width: 150px;
    }

    .quantity-selector {
        width: 125px;
    }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>
<script>
export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        salepage_id: {
            required: true,
            type: Number
        },
        is_preview: {
            required: false,
            type: Boolean,
            default: false
        },
        base_url: {
            required: true,
            type: String
        },
        pre_selected_menu: {
            required: false,
            type: Number
        }
    },
    data() {
        return {
            api_url: this.base_url,
            salePage: {},
            menus: [],
            salePageBodies: [],
            salePageProduct: [],
            formSalePageData: null,
            totalPrice: 0,
            queue: [],
            products: {
                product_id: "",
                quantity: "",
                product_data: {}
            },
            cartModalOpen: false,
            selectedMenu:
                this.pre_selected_menu != 0 ? this.pre_selected_menu : null,
            currency: null,
            dark_bg: [
                "#DC143C",
                "#9932CC",
                "#28a745",
                "#FF1493",
                "#8B4513",
                "#000000"
            ]
        };
    },
    mounted() {
        this.getSalePage();
        this.getMenu();
        this.getSaleaPageProduct();
        this.getFormData();
        this.checkDomain();
        this.analyticView();
        this.onClickCalltoAction();
        this.getCurrency();
    },
    computed: {
        styleObject: function() {
            return {
                "--button-color": this.salePage.button_color,
                "--button-text": this.salePage.button_text,
                "--button-background-color-hover": this.salePage.menu_text,
                "--button-border-color-hover": this.salePage.menu_color,
                "--button-color-hover": this.salePage.menu_color
            };
        },
        isbgDark: function() {
            return this.dark_bg.includes(this.salePage.background);
        }
    },
    methods: {
        onClickCalltoAction() {
            document.addEventListener("click", e => {
                if (e.target.className === "call-to-action") {
                    const url = e.target.parentElement.href;
                    this.analyticCallToAction(url);
                }
            });
        },
        async analyticView() {
            const device = this.gediveviceType();
            const url = this.getCurrentUrl();
            let form = {
                salepage_id: this.salepage_id,
                device: device,
                url: url,
                shop: this.shop
            };
            await axios
                .post(`${this.api_url}/api/analytic-salepage`, form)
                .then(res => {
                    console.log("res data", res.data);
                });
        },
        async analyticCallToAction(url_click) {
            const device = this.gediveviceType();
            const url = this.getCurrentUrl();
            let form = {
                salepage_id: this.salepage_id,
                device: device,
                url_click: url_click,
                url: url,
                shop: this.shop
            };

            await axios
                .post(
                    `${this.api_url}/api/analytic-salepage/call-to-action`,
                    form
                )
                .then(res => {
                    console.log("res data", res.data);
                });
        },
        getCurrentUrl() {
            return window.location.href;
        },
        gediveviceType() {
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            if (
                /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
                    ua
                )
            ) {
                return "mobile";
            }
            return "desktop";
        },
        async getFormData() {
            await axios
                .get(
                    `${this.api_url}/ajax/frontend/s/${this.shop}/salepage/${this.salepage_id}/forms`
                )
                .then(res => {
                    this.formSalePageData = res.data.formSalePage;
                });
        },
        getSaleaPageProduct() {
            const url = `${this.api_url}/ajax/frontend/s/${this.shop}/salepage/${this.salepage_id}/product`;
            axios
                .get(url, { params: { menu: this.selectedMenu } })
                .then(res => {
                    this.salePageProduct = res.data.product;
                });
        },
        getSalePage() {
            const url = `${this.api_url}/ajax/frontend/s/${this.shop}/salepage/${this.salepage_id}`;
            axios.get(url).then(res => {
                const {
                    date_from,
                    date_to,
                    type,
                    slug,
                    background,
                    menu_color,
                    menu_text,
                    button_color,
                    button_text,
                    menu_style,
                    title
                } = res.data.salepage;
                this.salePage = {
                    type: type,
                    date_from: date_from ? new Date(date_from) : null,
                    date_to: date_to ? new Date(date_to) : null,
                    slug: slug ? slug : null,
                    background: background ? background : null,
                    menu_color: menu_color ? menu_color : "#fdd836",
                    menu_text: menu_text ? menu_text : "#000000",
                    button_color: button_color ? button_color : "#28a745",
                    button_text: button_text ? button_text : "#ffffff",
                    menu_style: menu_style ? menu_style : "grid",
                    title: title ? title : null
                };
            });
        },
        getMenu() {
            const url = `${this.api_url}/ajax/frontend/s/${this.shop}/salepage/${this.salepage_id}/menu`;

            axios.get(url).then(res => {
                this.menus = res.data.menus;
            });
        },
        checkFlashSale() {
            const { date_from, date_to } = this.salePage;
            if (date_from && date_to) {
                let now = new Date();
                let dateFrom = new Date(this.salePage.date_from);
                let dateTo = new Date(this.salePage.date_to);

                if (dateFrom < now && dateTo > now) {
                    return true;
                }
            }
            return false;
        },
        checkStock(queueIndex) {
            if (
                this.queue[queueIndex].quantity >
                this.queue[queueIndex].product_data.stock_balance
            ) {
                this.queue[queueIndex].quantity = this.queue[
                    queueIndex
                ].product_data.stock_balance;
            }

            if (this.queue[queueIndex].quantity < 1) {
                this.queue[queueIndex].quantity = 1;
            }
        },
        getSalePageBodies() {
            const url = `${this.api_url}/backend/s/${this.shop}/salepages/${this.salepage_id}/bodies`;
            axios.get(url).then(res => {
                this.salePageBodies = res.data;
            });
        },
        updateQueueQuantity() {
            let orderData = this.queue.map(i => {
                let sedivata = {
                    ...{ product_id: i.product_id },
                    ...{
                        quantity:
                            i.quantity > 1
                                ? i.quantity > i.product_data.stock_balance
                                    ? i.product_data.stock_balance
                                    : i.quantity
                                : 1
                    }
                };
                return sedivata;
            });

            let producdivata = JSON.stringify(orderData);
            this.setCookies(this.salePage.slug, producdivata, 1);
            this.totalPrice = this.getQueueTotalPrice();
        },

        getQueueTotalPrice() {
            let totalPrice = 0;
            this.queue.forEach(i => {
                totalPrice += i.product_data.price * i.quantity;
            });
            return totalPrice;
        },
        addToCart(productId, quantity) {
            // check stock
            const stockBalanceProduct = this.salePageProduct.find(product => {
                return product.id == productId;
            }).stock_balance;

            //add to cart
            let existQueue = this.queue.find(id => {
                return id.product_id == productId;
            });

            if (existQueue) {
                this.queue.forEach((element, index) => {
                    if (element.product_id == existQueue.product_id) {
                        this.queue[index]["quantity"] =
                            this.queue[index]["quantity"] + quantity;
                        if (
                            this.queue[index]["quantity"] > stockBalanceProduct
                        ) {
                            this.queue[index]["quantity"] = this.queue[index][
                                "quantity"
                            ] = stockBalanceProduct;
                            this.$swal({
                                icon: "error",
                                title: "ขอโทษค่ะ",
                                text:
                                    "ไม่สามารถเพิ่มจำนวนสินค้าได้อีก เนื่องจากจำนวนสินค้าถึงจำนวนที่กำหนดแล้ว",
                                showConfirmButton: true
                            });
                        }
                    }
                });
            }
            if (!existQueue) {
                const queueData = this.salePageProduct.find(i => {
                    return i.id == productId;
                });

                this.products.product_data = queueData;
                this.products.product_id = productId;
                this.products.quantity = quantity;

                this.queue.push({ ...this.products });
            }
            this.updateQueueQuantity();
        },
        removeProduct(id) {
            let index = this.queue
                .map(i => {
                    return i.product_id;
                })
                .indexOf(id);
            this.queue.splice(index, 1);

            this.updateQueueQuantity();
        },
        setCookies(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        checkDomain() {
            let url;
            if (
                `${window.location.protocol}//${window.location.hostname}` ==
                this.api_url
            ) {
                url = `${this.api_url}/${this.salePage.slug}`;
            } else {
                url = `${window.location.protocol}//${window.location.hostname}`;
            }
            return url;
        },
        orderPurchase() {
            this.updateQueueQuantity();

            if (this.queue.length == 0) {
                this.$swal({
                    icon: "error",
                    title: "ขอโทษค่ะ",
                    text: "กรุณาเพิ่มสินค้าในตะกร้า",
                    showConfirmButton: true
                });
                return;
            }

            let url = this.checkDomain();

            window.location.href = `${url}/confirm-order`;
        },
        openCartModal() {
            this.cartModalOpen = true;
        },
        changeSelectedMenu(menu) {
            this.selectedMenu = menu;
        },
        scrollToMenu(menuId) {
            let menu = this.menus.find(menu => menu.id == menuId);

            if (menu) {
                if (menu.link_type == "category") {
                    document
                        .getElementById("salepage-product")
                        .scrollIntoView();
                } else if (menu.link_type == "home") {
                    document.getElementById("salepage-top").scrollIntoView();
                }
            }
        },
        async getCurrency() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currency`)
                .then(res => {
                    this.currency = res.data.currency;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        }
    },
    watch: {
        selectedMenu: function(value) {
            this.getSaleaPageProduct();
            this.scrollToMenu(value);
        }
    }
};
</script>
